import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import Swal from "sweetalert2";

const PoLogsModal = ({
  show,
  handleClose,
  item,
  handleSinglePOAction
}) => {
  // Safe access to user email
  const user = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const userEmail = user?.data?.user?.email || "";
  const userRole =
    user?.data?.user?.role?.toLowerCase() || "";

  const isDirector = userRole === "director";
  if (!item) return null;
  const actionableStatuses = new Set([
    "Assigned-To-SuperAdmin",
    "Assigned-To-Maker",
    "Assigned-To-Checker",
    "Generated"
  ]);

  const canTakePOAction =
    actionableStatuses.has(
      item?.status
    );



  const getSupplier = (it) => {
    if (it?.supplierName) {
      return `${it.supplierName}${it.supplierState ? ` (${it.supplierState})` : ""}`;
    }

    if (it?.supplier?.name) {
      return it.supplier.name;
    }

    return "N/A";
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" enforceFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title>PO Logs - {item?.poNumber || "N/A"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container-fluid">
          {/* PO Details */}
          <h5 className="mb-3">PO Details</h5>
          <Table bordered hover size="sm">
            <tbody>
              <tr>
                <th>PO Number</th>
                <td>{item.poNumber || "N/A"}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{item.status || "N/A"}</td>
              </tr>
              {isDirector && (
                <tr>
                  <th>GST</th>
                  <td>
                    ₹
                    {(
                      Number(item?.totalCGSTAmount || 0) +
                      Number(item?.totalSGSTAmount || 0) +
                      Number(item?.totalIGSTAmount || 0)
                    ).toFixed(2)}
                  </td>
                </tr>
              )}

              {isDirector && (
                <tr>
                  <th>Total Amount</th>
                  <td>
                    ₹{Number(item?.totalAmount || 0).toFixed(2)}
                  </td>
                </tr>
              )}

              <tr>
                <th>Created By</th>
                <td>
                  {item?.createdBy?.name ||
                    item?.createdByName ||
                    (typeof item?.createdBy === "string" ? item.createdBy : "") ||
                    "N/A"}
                </td>
              </tr>
              <tr>
                <th>Created At</th>
                <td>{item?.createdAt ? new Date(item.createdAt).toLocaleString() : "N/A"}</td>
              </tr>
            </tbody>
          </Table>

          {/* Items Table */}
          <h6>Items</h6>
          <Table striped bordered hover responsive size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Part No</th>
                <th>Description</th>
                <th>Qty</th>
                {isDirector && <th>Rate</th>}
                {isDirector && <th>Amount</th>}
                {isDirector && <th>Supplier</th>}
              </tr>
            </thead>
            <tbody>
              {item?.items?.map((it, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{it?.partNo || "N/A"}</td>
                  <td className="scrollable-description">{it?.description || "N/A"}</td>
                  <td>{it?.approveQty || 0}</td>
                  {isDirector && (
                    <td>
                      ₹{Number(it?.rate || 0).toFixed(2)}
                    </td>
                  )}

                  {isDirector && (
                    <td>
                      ₹{(
                        Number(it?.approveQty || 0) *
                        Number(it?.rate || 0)
                      ).toFixed(2)}
                    </td>
                  )}

                  {isDirector && (
                    <td>{getSupplier(it)}</td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>

          {/* History Table */}
          {item?.history?.length > 0 && (
            <>
              <h6 className="mt-4">History</h6>
              <Table bordered hover responsive size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th colSpan="2">Status From-TO</th>
                    <th>Remark</th>
                    <th>Updated By</th>
                    <th>Role</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {item.history
                    .slice()
                    .sort(
                      (a, b) =>
                        new Date(b.date || b.updatedAt) - new Date(a.date || a.updatedAt)
                    )
                    .map((h, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{h?.fromStatus || "N/A"}</td>
                        <td>{h?.toStatus || "N/A"}</td>
                        <td>
                          {Array.isArray(h?.remark)
                            ? h.remark.map((r, i) => <div key={i}>{r}</div>)
                            : h?.remark || "N/A"}
                        </td>
                        <td>{h?.user?.name || "N/A"}</td>
                        <td>
                          {h?.role === "pomaker"
                            ? "PO Maker"
                            : h?.role === "pochecker"
                              ? "PO Checker"
                              : h?.role === "director"
                                ? "Director"
                                : h?.role || "N/A"}
                        </td>
                        <td>{h?.date || h?.updatedAt ? new Date(h.date || h.updatedAt).toLocaleString() : "N/A"}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center">
        {(
          (
            isDirector ||
            [
              "ravidagdi@gmail.com",
              "dd@indigoinfraprojects.com",
              "ajitindigo@gmail.com"
            ]
              .map(
                (email) =>
                  email.toLowerCase()
              )
              .includes(
                userEmail?.toLowerCase()
              )
          ) &&
          canTakePOAction
        ) && (
            <>
              <Button
                variant="success"
                className="me-2"
                onClick={async () => {

                  try {

                    const success =
                      await handleSinglePOAction(
                        item?._id,
                        "Approved",
                        true
                      );


                    if (success) {

                      handleClose();

                    }


                  } catch (error) {

                    console.error(
                      "Error approving PO:",
                      error
                    );

                    Swal.fire(
                      "Error",
                      "Failed to approve PO. Please try again.",
                      "error"
                    );
                  }
                }}
              >
                <i className="fa fa-check me-1"></i> Approve
              </Button>

              <Button
                variant="warning"
                className="me-2"
                onClick={async () => {

                  try {

                    const success =
                      await handleSinglePOAction(
                        item?._id,
                        "Send-Back",
                        true
                      );


                    if (success) {

                      handleClose();

                    }


                  } catch (error) {

                    console.error(
                      "Error sending back PO:",
                      error
                    );

                    Swal.fire(
                      "Error",
                      "Failed to send back PO. Please try again.",
                      "error"
                    );
                  }
                }}
              >
                <i className="fa fa-reply me-1"></i> Send to Maker
              </Button>
            </>
          )}

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PoLogsModal;
